import { Row, Col, Modal, Tooltip, Button } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import AdminLinksComponent from '../../../components/admin/AdminLinksComponent';
import { TableHeader, Pagination, Search } from '../../../components/DataTable';
import { useEffect, useState, useMemo, useRef } from 'react';
import CartItemForOrderComponent from '../../../components/CartItemForOrderComponent';
import OrderItemForOrderPageComponent from './OrderItemForOrderPageComponent';
import './invoicePDF.css';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
//import { Tooltip } from '@mui/material';
import { useTrackEvents } from '../../trackEvents/useTrackEvents';
import { useDispatch, useSelector } from 'react-redux';

const OrdersPageComponent = ({ getOrders, deleteOrder }) => {
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [orderDeleted, setOrderDeleted] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const [qbthisMonthTotal, setQbThisMonthTotal] = useState(0);
  const [qblastMonthTotal, setQbLastMonthTotal] = useState(0);
  const [qbthisMonthBalanceToClear, setQbThisMonthBalanceToClear] = useState(0);
  const [qblastMonthBalanceToClear, setQbLastMonthBalanceToClear] = useState(0);
  const [qbthisMonthProcessedTotal, setQbThisMonthProcessedTotal] = useState(0);
  const [qblastMonthProcessedTotal, setQbLastMonthProcessedTotal] = useState(0);
  const [totalBalanceToClear, setTotalBalanceToClear] = useState(0);
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  /* sort table */
  // #region
  const [totalItems, setTotalItems] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(() => {
    const page = Number(searchParams.get('pageNum'));
    return Number.isSafeInteger(page) && page > 0 ? page : 1;
  });
  const pagesByFilter = useRef({});
  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState({ field: 'createdAt', order: 'desc' });

  const ITEMS_PER_PAGE = 40;

  const restorePage = (page) => {
    setCurrentPage(page);
    const params = new URLSearchParams(searchParams);
    params.set('pageNum', String(page));
    setSearchParams(params, { replace: true });
  };

  const handleFilterChange = (event) => {
    const nextFilter = event.target.value;
    pagesByFilter.current[filterValue] = Number(currentPage);
    setFilterValue(nextFilter);
    restorePage(pagesByFilter.current[nextFilter] || 1);
  };

  const handleSearch = (value) => {
    setSearch(value);
    pagesByFilter.current = {};
    restorePage(1);
  };

  const headers = [
    { name: 'No#', field: 'index', sortable: false },
    { name: 'Customer', field: 'name', sortable: true },
    { name: 'Company', field: 'userCompany', sortable: true },
    { name: 'Delivery Site', field: 'deliverySite', sortable: true },
    { name: 'Total Amount', field: 'orderTotal.cartSubtotal', sortable: true },
    { name: 'Items', field: 'items', sortable: false },
    { name: 'Dsp', field: 'isDelivered', sortable: true },
    { name: 'Inv', field: 'invSent', sortable: false },
    { name: 'Paid', field: 'isPaid', sortable: false },
    { name: 'PO#', field: 'purchaseNumber', sortable: true },
    { name: 'Invoice#', field: 'invoiceNumber', sortable: true },
    { name: 'Admin Note', field: 'adminNote', sortable: true },
    { name: 'Order Date', field: 'createdAt', sortable: true },
    {
      name: 'Delete',
      field: '',
      sortable: false,
      hidden: !userInfo?.isSuperDeleteAdmin,
    },
  ];

  const visibleHeaders = headers.filter((header) => !header.hidden);

  //Tracking user Interactions
  useTrackEvents();
  // var trackData = localStorage.getItem("trackData")
  // console.log("trackData", trackData);

  const ordersData = useMemo(() => {
    let computedOrders = orders;
    if (filterValue === 'undispatched') {
      computedOrders = computedOrders.filter((order) => !order.isDelivered);
    } else if (filterValue === 'backOrder') {
      computedOrders = computedOrders.filter(
        (order) => order.backOrder === true,
      );
    } else if (filterValue === 'invNotSent') {
      computedOrders = computedOrders.filter(
        (order) => !order.invSent && order.isDelivered,
      );
    } else if (filterValue === 'uniforms') {
      computedOrders = computedOrders.filter(
        (order) => order.orderNote === 'Uniform',
      );
    }

    if (search) {
      computedOrders = computedOrders.filter(
        (order) =>
          order.createdAt?.toUpperCase().includes(search.toUpperCase()) ||
          order.purchaseNumber?.toUpperCase().includes(search.toUpperCase()) ||
          order.userCompany?.toUpperCase().includes(search.toUpperCase()) ||
          order.deliverySite?.toUpperCase().includes(search.toUpperCase()) ||
          order.userName?.toUpperCase().includes(search.toUpperCase()) ||
          String(order.orderTotal.cartSubtotal)
            .toUpperCase()
            .includes(search.toUpperCase()) ||
          order.invoiceNumber?.toUpperCase().includes(search.toUpperCase()) ||
          order.userCompany?.toUpperCase().includes(search.toUpperCase()) ||
          order.adminNote?.toUpperCase().includes(search.toUpperCase()) ||
          (
            order.user?.name.toUpperCase() +
            ' ' +
            order.user?.lastName.toUpperCase()
          ).includes(search.toUpperCase()) ||
          order.cartItems.some((cartItem) =>
            cartItem.name?.toUpperCase().includes(search.toUpperCase()),
          ) ||
          order.cartItems.some(
            (cartItem) =>
              cartItem.cartProducts &&
              cartItem.cartProducts.length > 0 &&
              cartItem.cartProducts[0].ctlsku &&
              cartItem.cartProducts[0].ctlsku
                .toUpperCase()
                .includes(search.toUpperCase()),
          ) ||
          order.cartItems.some(
            (cartItem) =>
              cartItem.cartProducts &&
              cartItem.cartProducts.length > 0 &&
              cartItem.cartProducts[0].suppliersku &&
              cartItem.cartProducts[0].suppliersku
                .toUpperCase()
                .includes(search.toUpperCase()),
          ),
      );
    }

    setTotalItems(computedOrders.length);

    //Sorting products
    // as localeCompare only can compare String, we have to update it as below.
    // nested property 嵌套的数据，不能直接获取，容易报错。所以用下面的公式去解析 orderTotal.cartSubtotal
    const getNestedProperty = (obj, path) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    if (sorting.field) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedOrders = computedOrders.sort((a, b) => {
        const fieldA = getNestedProperty(a, sorting.field);
        const fieldB = getNestedProperty(b, sorting.field);

        if (typeof fieldA === 'number' && typeof fieldB === 'number') {
          return reversed * (fieldA - fieldB);
        } else if (typeof fieldA === 'string' && typeof fieldB === 'string') {
          return reversed * fieldA.localeCompare(fieldB);
        } else {
          // If field types are different, compare their string representations
          return reversed * String(fieldA).localeCompare(String(fieldB));
        }
      });
    }

    //Current Page slice
    return computedOrders.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE,
    );
  }, [orders, currentPage, search, sorting, filterValue]);

  // #endregion

  useEffect(() => {
    setLoadingOrders(true);
    getOrders()
      .then((orders) => setOrders(orders))
      .catch((er) =>
        console.log(
          er.response?.data?.message || er.message,
        ),
      )
      .finally(() => setLoadingOrders(false));
  }, [orderDeleted]);

  const deleteHandler = async (orderId) => {
    if (window.confirm('Are you sure?')) {
      deleteOrder(orderId);
      setOrderDeleted(true);
      setTimeout(() => {
        setOrderDeleted(false);
      }, 500);
    }
  };

  // order items Modal and Back Order
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (orderId) => {
    setSelectedOrderId(orderId);
    setShow(true);
  };

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const getOrderStyle = (order) => ({
    cursor: 'pointer',
    color: order.backOrder ? 'red' : 'black',
    fontWeight: order.backOrder ? 'bold' : 'normal',
  });

  //Purchased products list.
  var orderProductsList = [];
  ordersData.map((order) => {
    order.cartItems.map((item) => {});
  });

  //Export to Excel
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const fileName = 'Order_products';

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(orderProductsList);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const columnWidths = [
    '3%',
    '10%',
    '20%',
    '15%',
    '10%',
    '3%',
    '3%',
    '3%',
    '8%',
    '6%',
    '15%',
    '8%',
    '2%',
  ];

  useEffect(() => {
    const thisMonth = new Date().getMonth();
    const lastMonth = thisMonth - 1;
    const thisYear = new Date().getFullYear();
    let thisMonthTotalValue = 0;
    let lastMonthTotalValue = 0;
    let thisMonthProcesseTotal = 0;
    let lastMonthProcessedTotal = 0;
    let thisMonthBalanceToClear = 0;
    let lastMonthBalanceToClear = 0;
    let totalBalanceToClear = 0;

    orders.map((order) => {
      const month = new Date(order.createdAt).getMonth();
      const year = new Date(order.createdAt).getFullYear();
      const monthPO = new Date(order.updatedAt).getMonth();

      if (order.isDelivered) {
        const subtotal = order.orderTotal.cartSubtotal;
        if (monthPO === thisMonth && year === thisYear) {
          thisMonthProcesseTotal += subtotal;
        } else if (monthPO === lastMonth && year === thisYear) {
          lastMonthProcessedTotal += subtotal;
        }

        const balance = order.balance;
        totalBalanceToClear += balance;
      }

      if (month === thisMonth && year === thisYear) {
        thisMonthTotalValue =
          thisMonthTotalValue + order.orderTotal.cartSubtotal;
      } else if (month === lastMonth && year === thisYear) {
        lastMonthTotalValue =
          lastMonthTotalValue + order.orderTotal.cartSubtotal;
      }
    });
    setQbThisMonthTotal(thisMonthTotalValue.toFixed(2));
    setQbLastMonthTotal(lastMonthTotalValue.toFixed(2));
    setQbThisMonthProcessedTotal(thisMonthProcesseTotal.toFixed(2));
    setQbLastMonthProcessedTotal(lastMonthProcessedTotal.toFixed(2));
    setTotalBalanceToClear(totalBalanceToClear.toFixed(2));
  }, [orders]);

  return (
    <>
      <Row className="content-container m-5">
        <Col md={2}>
          <AdminLinksComponent />
        </Col>
        <Col md={10}>
          <div className="row">
            <div className="col-md-5" style={{ width: '30%' }}>
              <h1>ORDERS </h1>
            </div>
            {userInfo.isSuperAdmin === true ? (
              <>
                <div className="row">
                  <div className="col-12">
                    <div
                      className="p-2 mb-1 rounded"
                      style={{ backgroundColor: '#D3D3D3', height: '150px' }}
                    >
                      <div className="row mt-2">
                        <div className="col-md-1 mb-3"></div>
                        <div className="col-md-5 mb-3">
                          <div className="p-2 rounded shadow-sm bg-white h-100">
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <span>This Month's Orders Total:</span>
                              <b>
                                $
                                {new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(qbthisMonthTotal)}
                              </b>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <span>This Month Processed Orders Total:</span>
                              <b>
                                $
                                {new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(qbthisMonthProcessedTotal)}
                              </b>
                            </div>
                          </div>
                        </div>

                        {/* Last Month Summary */}
                        <div className="col-md-5 mb-3">
                          <div className="p-2 rounded shadow-sm bg-white h-100">
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <span>Last Month's Orders Total:</span>
                              <b>
                                $
                                {new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(qblastMonthTotal)}
                              </b>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <span>Last Month Processed Orders Total:</span>
                              <b>
                                $
                                {new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(qblastMonthProcessedTotal)}
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-0 flex">
                        <div className="col-md-3 mb-3"></div>
                        <div className="col-md-5 mb-3">
                          <div className="p-2 rounded shadow-sm bg-white h-100">
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <span>Balance To Clear From Clients:</span>
                              <b>
                                $
                                {new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(totalBalanceToClear)}
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : userInfo.isSales === true ? (
              <>
                <div className="row">
                  <div className="col-12">
                    <div
                      className="p-5 rounded"
                      style={{ backgroundColor: '#D3D3D3', height: '150px' }}
                    >
                      <div className="row mt-2">
                        <div className="col-md-3 mb-3"></div>
                        <div className="col-md-5 mb-3">
                          <div className="p-2 rounded shadow-sm bg-white h-100">
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <span>This Month's Orders Total:</span>
                              <b>
                                $
                                {new Intl.NumberFormat('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(qbthisMonthTotal)}
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}
          </div>

          <div className="row">
            <div className="col-md-5">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
              />
            </div>
            <div className="col-md-3">
              {/* <Button
                variant="success"
                onClick={(e) => exportToExcel(fileName)}
                style={{ cursor: "pointer", fontSize: 14 }}
              >
                Excel Export All Products
              </Button> */}
            </div>
            {/* filter and search */}
            <div className="col-md-4 d-flex justify-content-between">
              <select
                value={filterValue}
                onChange={handleFilterChange}
                className="form-select me-3"
              >
                <option value="">All Orders</option>
                <option value="undispatched">Undispatched</option>
                <option value="backOrder">Back Order</option>
                <option value="invNotSent">Inv Not Sent</option>
                <option value="uniforms">Uniforms</option>
              </select>
              <Search onSearch={handleSearch} />
            </div>
          </div>
          <table className="table table-striped table-sm">
            <TableHeader
              headers={visibleHeaders}
              onSorting={(field, order) => setSorting({ field, order })}
              widths={columnWidths}
            />
            <tbody>
              {loadingOrders ? (
                <tr>
                  <td colSpan={visibleHeaders.length}>
                    <div role="status">
                      <img
                        src="/loading-gif.gif"
                        alt="Loading"
                        style={{ display: "block", margin: "auto", width: "200px", marginTop: "10%" }}
                      />
                    </div>
                  </td>
                </tr>
              ) : ordersData.map((order, idx) => (
                <tr
                  key={idx}
                  style={{
                    backgroundColor:
                      !order.isDelivered &&
                      new Date() - new Date(order.createdAt) >
                        7 * 24 * 60 * 60 * 1000
                        ? 'orange'
                        : 'white',
                  }}
                >
                  <td className="no-wrap-td">{idx + 1}</td>
                  <td
                    onClick={() => handleShow(order._id)}
                    style={getOrderStyle(order)}
                    className="no-wrap-td"
                  >
                    {order.user !== null ? (
                      <>
                        {order.user.name.charAt(0).toUpperCase() +
                          order.user.name.slice(1)}{' '}
                        {order.user.lastName.charAt(0).toUpperCase() +
                          order.user.lastName.slice(1)}
                      </>
                    ) : null}
                  </td>
                  <td
                    onClick={() => handleShow(order._id)}
                    style={getOrderStyle(order)}
                    className="no-wrap-td"
                  >
                    {order.userCompany}
                  </td>
                  <td
                    onClick={() => handleShow(order._id)}
                    style={getOrderStyle(order)}
                    className="no-wrap-td"
                  >
                    {order.deliverySite.toUpperCase()}
                  </td>
                  <td
                    onClick={() => handleShow(order._id)}
                    style={getOrderStyle(order)}
                    className="no-wrap-td"
                  >
                    $ {order.orderTotal.cartSubtotal.toLocaleString()}
                  </td>
                  <td
                    onClick={() => handleShow(order._id)}
                    style={getOrderStyle(order)}
                    className="no-wrap-td"
                  >
                    {order.cartItems.length}
                  </td>

                  <td className="no-wrap-td">
                    {order.isDelivered ? (
                      order.trackLink.includes('false') ? (
                        <Link
                          to={`/admin/order-details/${order._id}`}
                          style={{ color: 'green' }}
                        >
                          <i className="bi bi-truck"></i>
                        </Link>
                      ) : (
                        <a
                          href={order.trackLink}
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: 'green' }}
                        >
                          <i className="bi bi-truck"></i>
                        </a>
                      )
                    ) : (
                      <i className="bi bi-x-lg text-danger"></i>
                    )}
                  </td>
                  <td className="no-wrap-td">
                    {order.invSent ? (
                      <i className="bi bi-check-circle-fill text-success" />
                    ) : (
                      <i className="bi bi-x-lg text-danger"></i>
                    )}
                  </td>
                  <td className="no-wrap-td">
                    {order.isPaid ? (
                      <i className="bi bi-check-circle-fill text-success" />
                    ) : (
                      <i className="bi bi-x-lg text-danger"></i>
                    )}
                  </td>
                  <td
                    onClick={() => handleShow(order._id)}
                    style={getOrderStyle(order)}
                    className="no-wrap-td"
                  >
                    {order.purchaseNumber}
                  </td>
                  <td className="no-wrap-td">
                    <Link
                      to={`/admin/order-details/${order._id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {order.invoiceNumber}{' '}
                      {userInfo.isSuperAdmin === true ||
                      userInfo.isSales === true ? (
                        <i className="bi bi-box-arrow-in-right"></i>
                      ) : (
                        ''
                      )}
                    </Link>
                  </td>
                  <td className="no-wrap-td">{order.adminNote}</td>
                  <td className="no-wrap-td">
                    {order.createdAt.substring(0, 10)}
                  </td>
                  <td className="no-wrap-td">
                    {userInfo.isSuperAdmin === true &&
                    userInfo.isSuperDeleteAdmin === true ? (
                      <button
                        variant="danger"
                        className="btn-sm btn-light"
                        onClick={() => deleteHandler(order._id)}
                        style={{ border: 'none' }}
                      >
                        <i className="bi bi-x-circle"></i>
                      </button>
                    ) : (
                      ''
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="col-md-5">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose} className="order_preview_items">
        <OrderItemForOrderPageComponent id={selectedOrderId} />
      </Modal>
    </>
  );
};

export default OrdersPageComponent;
